import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import {
  CustomLabel,
  CustomTitle,
} from "../../components/Custom/CustomTypography";
import { CustomValue } from "../../components/Custom/CustomTypography";
import { useLocation } from "react-router-dom";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { buyingInterest } from "../../Data/fieldData";
import CustomTextField from "../../components/Custom/CustomTextField";
import { useAlert } from "../../components/Alert";

export default function DetailedAvailableCommodity() {
  const [formData, setFormData] = useState({});
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const fpoId = queryParams.get("fpoId");
  const stateId = queryParams.get("stateId");
  const commodityId = queryParams.get("commodityId");

  const details = data.fpo
    ? [
        { label: "FPO Name", value: data.fpo.full_name },
        { label: "Farmers Selected Crop", value: data.farmers.length },
        { label: "Quantity(Kg)", value: `${data.fpo.total_harvest} Kg` },
        { label: "Last Harvest Date", value: data.fpo.last_harvest_date },
      ]
    : [];

  const fetchFpoDetails = () => {
    api
      .get(
        `/buyer/fpo-farmers/?fpo_id=${fpoId}&commodity_id=${commodityId}&state_id=${stateId}`
      )
      .then((result) => {
        setData(result.data);
        setLoading(false);
        console.log(data);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFpoDetails();
  }, []);

  const postBuyingInterest = async () => {
    const updatedFormData = {
      ...formData,
      to_user: fpoId,
      commodity: commodityId,
    };

    try {
      const response = await api.post(
        "/buyer/expression-of-interest/",
        updatedFormData
      );
      if (response.status === 201) {
        showAlert("success", "Data submitted successfully");
        navigate("/buyer/bids-trades");
      } else {
        console.log("posterr", response.data);
        showAlert("error", "Error submitting data");
      }
    } catch (e) {
      console.log("posterr", e.response.data[0]);
      showAlert("error", e.response.data[0]);
    }
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    console.log(formData);
  };

  console.log(data);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
            marginBottom: "100px",
          }}
        >
          <CustomTitle>{data.fpo ? data.fpo.commodity_name : ""}</CustomTitle>

          {details.map(({ label, value }, index) => (
            <Grid container spacing={2} key={index}>
              <Grid item xs={6}>
                <CustomLabel>
                  <Typography variant="body1" fontWeight="bold">
                    {label}:
                  </Typography>
                </CustomLabel>
              </Grid>
              <Grid item xs={6}>
                <CustomValue>
                  <Typography variant="body1">{value}</Typography>
                </CustomValue>
              </Grid>
            </Grid>
          ))}

          <Box sx={{ marginTop: "10px" }}>
            <CustomLabel>{"Send an expression of interest"}</CustomLabel>
          </Box>
          <Grid container>
            <Grid item xs={12}>
              {buyingInterest.map((field) => (
                <>
                  {field.type === "number" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                    />
                  )}

                  {field.type === "date" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                    />
                  )}
                </>
              ))}
            </Grid>

            <CustomButton
              hideIcon
              onClick={() => {
                postBuyingInterest();
              }}
            >
              {t("Confirm")}
            </CustomButton>
          </Grid>

          <CustomLabel>{t("Farmers List")}</CustomLabel>
          {data.farmers?.map((farmer, index) => (
            <div style={{ width: "100%", marginTop: "9px" }} key={index}>
              <ListGenericCard
                key={index}
                title={`${farmer.farmer_name}`}
                subtitle={[`${farmer.estimated_harvest} Kg`]}
                onClick={() => {
                  console.log("Farmer Id");
                }}
              />
            </div>
          ))}
        </Container>
      </LoaderContainer>
    </>
  );
}
